module.exports = __webpack_public_path__ + "static/media/DMC3-FM1.696f4bf3.czml";